import { Button, Dialog, Spinner } from '@economic/taco';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import internalApiClient from '../../../../../../../shared/util/api/internalApiClient';
import { SmartPayIntegrationModel } from '../../../types';
import { format } from 'date-fns';

const SysPageModal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let { agreementNumber } = location.state || ({} as any);

    const [content, setContent] = useState<JSX.Element | string | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!agreementNumber) onDialogClose();
        getAndSetAgreementInfo();
    }, [agreementNumber]);

    const getAndSetAgreementInfo = async () => {
        setIsLoading(true);
        try {
            const res = await internalApiClient.get(`/smartpay/integration/${agreementNumber}`);
            const content = generateContent(res.data);
            setContent(content);
        } catch (e) {
            if (e.response.status === 404) {
                setContent('Smart Pay integration not enabled for this agreement');
            } else {
                setContent('Something went wrong');
            }
        }
        setIsLoading(false);
    };

    const onDialogClose = () => {
        // remove modal hash
        navigate(location.pathname);
    };

    const generateContent = (integrationData: SmartPayIntegrationModel) => {
        const formatObjectArrayValue = value => {
            // if not array return value as strings
            if (!Array.isArray(value)) return value.toString();

            // generate content out of the arrays that might come in
            return value.map(item => (
                <div className="border-b-2 border-grey-dark last-of-type:border-0 ">
                    {typeof item === 'object' && !Array.isArray(item)
                        ? Object.keys(item).map(key => {
                              const separatedWordsName = key.split(/(?=[A-Z])/).join(' ');
                              const formattedName = separatedWordsName.charAt(0).toUpperCase() + separatedWordsName.slice(1);
                              return (
                                  <div>
                                      {`${formattedName}: ${
                                          formattedName.indexOf('Date') > 0 ? format(item[key], 'DD.MM.YYYY HH:mm:ss') : item[key]
                                      }`}
                                  </div>
                              );
                          })
                        : item}
                </div>
            ));
        };

        // returns JSX with sorted by name list. Each item is formated to have uppercase first letter and separate words with space.
        const dataArray = Object.keys(integrationData).map(key => {
            const separatedWordsName = key.split(/(?=[A-Z])/).join(' ');
            const formattedName = separatedWordsName.charAt(0).toUpperCase() + separatedWordsName.slice(1);
            return { name: formattedName, value: formatObjectArrayValue(integrationData[key]) };
        });

        return (
            <>
                {dataArray
                    .sort((a, b) => {
                        if (a.name < b.name) return -1;
                        if (a.name > b.name) return 1;
                        return 0;
                    })
                    .map((data, i) => (
                        <div key={i} className="flex py-2 border-t-2 border-grey-dark first-of-type:border-0">
                            <div className="flex-1 font-semibold flex items-center">{data.name}</div>
                            <div className="flex-1 ">
                                {data.name.indexOf('Date') > 0 ? format(data.value, 'DD.MM.YYYY HH:mm:ss') : data.value}
                            </div>
                        </div>
                    ))}
            </>
        );
    };

    return (
        <Dialog size="xs" onClose={onDialogClose} defaultOpen>
            <Dialog.Content aria-label="sys page smart pay details modal">
                <Dialog.Title>Smart Pay Integration Details - {agreementNumber}</Dialog.Title>
                {isLoading ? (
                    <div className="h-52 w-full flex items-center justify-center ">
                        <Spinner />
                    </div>
                ) : (
                    <div className="my-5">{content}</div>
                )}
                <Dialog.Footer>
                    <Button onClick={onDialogClose}>Close</Button>
                </Dialog.Footer>
            </Dialog.Content>
        </Dialog>
    );
};

export default SysPageModal;
